import graphql__49f5f0da82635168a911 from "./__generated__/MapDroppableZoneWithoutLimit_droppableZone.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useSelector } from "react-redux";
import { useMap } from "react-leaflet";
import { useDrop } from "react-dnd";

import { MAP_ELEMENT_DRAGGABLE_SOURCE } from "./MapElementDraggableSource";
import getLatLngFromContainerPoint from "../Utils/getLatLngFromContainerPoint";
import { useMapContext } from "./MapContext";

const MapDroppableZoneWithoutLimit = props => {
  const droppableZone = useFragment(
    MapDroppableZoneWithoutLimit_droppableZone,
    props.droppableZone
  );
  const { onClickInZone } = props;
  const leafletMap = useMap();

  const { mapKey } = useMapContext();

  const { draggedContribution: isContributionDragged, contributionCreation } =
    useSelector(({ map }) => map[mapKey].contribution);

  const displayZone = isContributionDragged || contributionCreation?.allowLocation;

  // This handles mobile clicks in the clickable container, and calls the click callback
  // if the click was inside the zone polygon's coordinates.
  const handleClick = useCallback(
    e => {
      if (!onClickInZone) return;

      const { lat, lng } = getLatLngFromContainerPoint(e.clientX, e.clientY, leafletMap);

      onClickInZone({ lat, lng });
    },
    [leafletMap, onClickInZone]
  );

  // This handles desktop draggable source drops inside the container and returns the
  // coordinates where it was dropped and whether it was dropped inside the zone polygon's
  // coordinates through the `isValid` property
  const drop = useCallback(
    (_, monitor) => {
      const { x, y } = monitor.getSourceClientOffset();
      const { style: draggedMarkerStyle } = monitor.getItem();

      const { lat, lng } = getLatLngFromContainerPoint(
        x, y, leafletMap, draggedMarkerStyle
      );

      return { x, y, lat, lng, isValid: true };
    },
    [leafletMap]
  );

  // Connect the react-dnd's context to the droppable zone. As for the `useDrag` hook,
  // the first returned element contains the collected props and the second argument
  // is a callback ref that allows us to connect our container to the react-dnd's event
  // handling system.
  const [, dropRef] = useDrop(() => ({
    accept: MAP_ELEMENT_DRAGGABLE_SOURCE,
    drop,
    collect: monitor => ({ isOver: monitor.isOver() })
  }));

  // The container is only shown in certain circumstances, most often when an element
  // is already being dragged to highlight the zone to the user and help him understand
  // that he should drop its source item into the container.
  if (!displayZone) return null;

  const backgroundColor = droppableZone?.style?.backgroundStyle?.color;
  const style = backgroundColor ? { backgroundColor } : {};

  return (
    <div
      onClick={handleClick}
      className="map-droppable-zone-without-limit"
      style={style}
      ref={dropRef}
    />
  );
};

const MapDroppableZoneWithoutLimit_droppableZone = graphql__49f5f0da82635168a911;

export default MapDroppableZoneWithoutLimit;
